exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".comment-sub-title[data-v-1ad5f2d7]{background:#ddd;color:#333;padding:8px 16px;font-size:.95rem;border-radius:3px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:justify;-ms-flex-pack:justify;justify-content:space-between}.board-comment-content[data-v-1ad5f2d7]{padding:20px;font-size:.95rem;color:#222;border-radius:3px;border:none;background-color:#f2f7f8;display:block;width:100%;height:120px}.btn-add-img[data-v-1ad5f2d7]{margin:0 8px 8px 0;background:#f2f7f8;width:80px;height:80px;text-align:center}.btn-add-img i[data-v-1ad5f2d7]{font-size:3rem;line-height:80px;color:#555}", ""]);

// exports
